export default "/_next/static/images/section-5-53df396cd53f70ec32bb9d065a1bb6cf.png";